var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotepad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    display: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "approved"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rejected"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cv"
  }), /*#__PURE__*/React.createElement("g", {
    id: "find_a_candidate"
  }), /*#__PURE__*/React.createElement("g", {
    id: "newspaper"
  }), /*#__PURE__*/React.createElement("g", {
    id: "interview"
  }), /*#__PURE__*/React.createElement("g", {
    id: "test"
  }), /*#__PURE__*/React.createElement("g", {
    id: "telephone"
  }), /*#__PURE__*/React.createElement("g", {
    id: "office"
  }), /*#__PURE__*/React.createElement("g", {
    id: "notepad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.96 28.939h-7.96c-1.158 0-2.1-.942-2.1-2.1v-20.159c0-1.158.941-2.1 2.1-2.1h1.855v.624c0 .497.403.9.9.9s.9-.403.9-.9v-.624h4.046v.624c0 .497.403.9.9.9s.9-.403.9-.9v-.624h4.045v.624c0 .497.403.9.9.9s.9-.403.9-.9v-.624h1.854c1.158 0 2.1.942 2.1 2.1v6.73c0 .497.403.9.9.9s.9-.403.9-.9v-6.73c0-2.15-1.75-3.9-3.9-3.9h-1.852v-.619c0-.497-.403-.9-.9-.9s-.9.403-.9.9v.619h-4.045v-.619c0-.497-.403-.9-.9-.9s-.9.403-.9.9v.619h-4.047v-.619c0-.497-.403-.9-.9-.9s-.9.403-.9.9v.619h-1.856c-2.15 0-3.9 1.75-3.9 3.9v20.16c0 2.15 1.75 3.9 3.9 3.9h7.96c.497 0 .9-.403.9-.9s-.403-.901-.9-.901z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.448 9.924h-11.692c-.497 0-.9.403-.9.9s.403.9.9.9h11.692c.497 0 .9-.403.9-.9s-.403-.9-.9-.9z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "white",
    strokeWidth: 1,
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.448 14.152h-11.692c-.497 0-.9.403-.9.9s.403.9.9.9h11.692c.497 0 .9-.403.9-.9s-.403-.9-.9-.9z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.603 18.379h-5.847c-.497 0-.9.403-.9.9s.403.9.9.9h5.847c.497 0 .9-.403.9-.9s-.403-.9-.9-.9z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.025 16.179c0-.001 0-.001 0 0-1.165-1.165-3.061-1.164-4.227 0l-9.02 9.02c-.347.347-.59.782-.703 1.257l-.533 2.232c-.132.558.031 1.132.437 1.537.312.312.724.479 1.151.479.128 0 .257-.015.385-.045l2.23-.533c.477-.113.911-.356 1.259-.704l9.02-9.02c.565-.564.876-1.314.876-2.113s-.31-1.546-.875-2.11zm-10.294 11.972c-.111.111-.25.189-.402.225l-1.973.471.47-1.973c.037-.152.115-.292.227-.404l6.492-6.492 1.68 1.68zm9.021-9.02-1.254 1.254-1.68-1.68 1.254-1.254c.231-.231.535-.347.84-.347s.608.116.84.347h.001c.224.224.348.522.348.839s-.124.616-.349.841z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "interviewer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "target"
  }), /*#__PURE__*/React.createElement("g", {
    id: "qna"
  }), /*#__PURE__*/React.createElement("g", {
    id: "briefcase"
  }), /*#__PURE__*/React.createElement("g", {
    id: "accepted"
  }), /*#__PURE__*/React.createElement("g", {
    id: "denied"
  }), /*#__PURE__*/React.createElement("g", {
    id: "negotiation"
  }), /*#__PURE__*/React.createElement("g", {
    id: "invitation"
  }), /*#__PURE__*/React.createElement("g", {
    id: "online_interview"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cover_letter"
  }), /*#__PURE__*/React.createElement("g", {
    id: "contact"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rating"
  }), /*#__PURE__*/React.createElement("g", {
    id: "resume"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.e132723b5773bf22281865c47b704755.svg";
export { ForwardRef as ReactComponent };